import { Image } from 'react-native'

const Images = {

  history: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/history_icon.png'),
  ),
  ic_chevron_down_dark: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/ic_chevron_down_dark.png'),
  ),
  contacts_white: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/contacts_white.png'),
  ),
  sms_light: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/sms_light.png'),
  ),
  success_light: Image.resolveAssetSource(
    require('./../Images/Icons/HIFI/success_light.png'),
  ),
  smsText: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/smsHistory.png'),
  ),
  close: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/close.png'),
  ),
  back: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/back.png'),
  ),
  smsText_white: Image.resolveAssetSource(
    require('./../Images/Icons/Icons/smsHistory_white.png'),
  ),

}

export default Images
